<template ref="subMenu">
  <el-submenu 
    v-if="menu.menuEntityList && menu.menuEntityList.length >= 1"
    :index="menu.id + ''">
    <template slot="title">
      <i :class="menu.icon || ''"></i>
      <span v-if="menu.permissionName == '前期寻源'">{{ this.showPurchaseSourceName(menu) }}</span>
      <span v-else-if="menu.permissionName == '供应商门户'">{{ this.showSupplyPortalName(menu) }}</span>
      <span v-else-if="menu.permissionName == '供应商协同'">{{ this.showSupplyClaName(menu) }}</span>
      <span v-else-if="menu.permissionName == '供应商索赔'">{{ this.showSupplyClaName(menu) }}</span>
      <span v-else-if="menu.permissionName == '供应商管理'">{{ this.showSupplierAccessInquiry(menu) }}</span>
      <span v-else-if="menu.permissionName == '量产阶段'">{{ this.showDeliveryName(menu) }}</span>
      <span v-else>{{ menu.permissionName }}</span>
      <span v-if="menu.permissionName == '前期寻源' && (this.count >0 || this.notReceivedPlmTechCount > 0)" style="font-weight:bold;color:red">&nbsp;{{this.count + this.notReceivedPlmTechCount}}</span>
      <span v-else-if="menu.permissionName == '供应商门户' && (this.quotationCount > 0 || this.publishedOrderCount > 0)" style="font-weight:bold;color:red">&nbsp;{{this.quotationCount + this.publishedOrderCount}}</span>
      <span v-else-if="menu.permissionName == '供应商协同' && this.supplyClaCount > 0" style="font-weight:bold;color:red">&nbsp;{{this.supplyClaCount}}</span>
      <span v-else-if="menu.permissionName == '供应商索赔' && this.supplyClaCount > 0" style="font-weight:bold;color:red">&nbsp;{{this.supplyClaCount}}</span>
      <span v-else-if="menu.permissionName == '供应商管理' && this.supplierAccessInquiry > 0" style="font-weight:bold;color:red">&nbsp;{{this.supplierAccessInquiry}}</span>
      <span v-else-if="menu.permissionName == '量产阶段' && this.deliveryCount > 0" style="font-weight:bold;color:red">&nbsp;{{this.deliveryCount}}</span>

    </template>
    <sub-menu
      v-for="item in menu.menuEntityList"
      :key="item.id"
      :menu="item"
      :dynamicMenuRoutes="dynamicMenuRoutes">
    </sub-menu>
  </el-submenu>
  <el-menu-item v-else :index="menu.id + ''" @click="gotoRouteHandle(menu)">
    <i :class="menu.icon || ''"></i>
    <span v-if="menu.permissionName == '任务管理'">{{ this.showName(menu) }}</span>
    <span v-else-if="menu.permissionName == '在线报价'">{{ this.showQuotationName(menu) }}</span>
    <span v-else-if="menu.permissionName == '订单管理'">{{ this.showPublishedOrderName(menu) }}</span>
    <span v-else-if="menu.permissionName == '定点申请接收'">{{ this.showPlmTechName(menu) }}</span>
    <span v-else-if="menu.permissionName == '供应商索赔单'">{{ this.showSupplyClaName(menu) }}</span>
    <span v-else-if="menu.permissionName == '准入供应商查询'">{{ this.showSupplierAccessInquiry(menu) }}</span>
    <span v-else-if="menu.permissionName == '交货单管理'">{{ this.showDeliveryName(menu) }}</span>
    <span v-else>{{ menu.permissionName }}</span>
    <span v-if="menu.permissionName == '任务管理' && this.count >0" style="font-weight:bold;color:red">&nbsp;{{&nbsp;this.count}}</span>
    <span v-else-if="menu.permissionName == '在线报价' && this.quotationCount >0" style="font-weight:bold;color:red">&nbsp;{{&nbsp;this.quotationCount}}</span>
    <span v-else-if="menu.permissionName == '订单管理' && this.publishedOrderCount >0" style="font-weight:bold;color:red">&nbsp;{{&nbsp;this.publishedOrderCount}}</span>
    <span v-else-if="menu.permissionName == '定点申请接收' && this.notReceivedPlmTechCount >0" style="font-weight:bold;color:red">&nbsp;{{&nbsp;this.notReceivedPlmTechCount}}</span>
    <span v-else-if="menu.permissionName == '供应商索赔单' && this.supplyClaCount > 0" style="font-weight:bold;color:red">&nbsp;{{&nbsp;this.supplyClaCount}}</span>
    <span v-else-if="menu.permissionName == '准入供应商查询' && this.supplierAccessInquiry > 0" style="font-weight:bold;color:red">&nbsp;{{&nbsp;this.supplierAccessInquiry}}</span>
    <span v-else-if="menu.permissionName == '交货单管理' && this.deliveryCount > 0" style="font-weight:bold;color:red">&nbsp;{{&nbsp;this.deliveryCount}}</span>

  </el-menu-item>
</template>

<script>
  import SubMenu from './sub-menu'
import {
    purchaseTaskListByStatus
} from "@/controller/purchaseTask";
import {
    quotationCountByLoginUser, publishedOrderCountByLoginUser, supplyClaCountByLoginUser
} from "@/controller/portal"
import {
    notReceivedPlmTechCount
} from "@/controller/plmTech"
  import {
    supplierAccessInquiry
  } from "@/controller/supplier"
  import {
    deliveryCountByLoginUser
  } from "@/controller/delivery"
  export default {
    name: 'sub-menu',
    data() {
        return {
            count:'',
            quotationCount:'',
            deliveryCount:'',
            publishedOrderCount:'',
            notReceivedPlmTechCount:'',
            supplyClaCount: '',
            supplierAccessInquiry:''
        }
    },
    
    props: {
      menu: {
        type: Object,
        required: true
      },
      dynamicMenuRoutes: {
        type: Array,
        required: true
      }
    },
    components: {
      SubMenu
    },
    computed: {
    },
    methods: {
      // 通过id与动态(菜单)路由进行匹配跳转至指定路由
      gotoRouteHandle (menu) {
        let route = this.dynamicMenuRoutes.filter(item => item.meta.id === menu.id)
        if (route.length >= 1) {
          this.$router.push({ name: route[0].name })
        }
      },
      showName(menu){
        this.getTaskStatusCount()
        return menu.permissionName
      },
      getTaskStatusCount(){
          purchaseTaskListByStatus({
                taskStatus: '1'
            }).then(data => {
                this.count = data
            })
      },
      showQuotationName(menu){
          this.getQuotationCount()
          return menu.permissionName
      },
      getQuotationCount(){
          quotationCountByLoginUser().then(data => {
              this.quotationCount = data
          })
      },
      showDeliveryName(menu){
        this.getDeliveryCount()
        return menu.permissionName
      },
      getDeliveryCount(){
        deliveryCountByLoginUser().then(data => {
          this.deliveryCount = data
        })
      },
      showPublishedOrderName(menu){
          this.getPublishedOrderCount()
          return menu.permissionName
      },
      getPublishedOrderCount(){
          publishedOrderCountByLoginUser().then(data => {
              this.publishedOrderCount = data
          })
      },
      showSupplyPortalName(menu){
          this.getQuotationCount()
          this.getPublishedOrderCount()
          return menu.permissionName
      },
      showPlmTechName(menu){
          this.getNotReceivedPlmTechCount()
          return menu.permissionName
      },
      getNotReceivedPlmTechCount(){
          notReceivedPlmTechCount().then(data => {
            this.notReceivedPlmTechCount = data
          })
      },
      getSupplierAccessInquiry(){
        supplierAccessInquiry().then(data => {
            this.supplierAccessInquiry = data<0?null:data
        })
      },
      showPurchaseSourceName(menu){
        this.getTaskStatusCount()
        this.getNotReceivedPlmTechCount()
        return menu.permissionName
      },
      showSupplyClaName(menu){
        this.getSupplyClaCount()
        return menu.permissionName
      },
      showSupplierAccessInquiry(menu){
        this.getSupplierAccessInquiry()
        return menu.permissionName
      },
      getSupplyClaCount(){
        supplyClaCountByLoginUser().then(data => {
            this.supplyClaCount = data
        })
      },
    }

  }
</script>
